import axios from "axios";
import { TableNames } from "./TableNames";

const API_BASE = process.env.REACT_APP_FASTAPI || "";

const createGenericAPI = (tableName) => ({
  create: (data) => axios.post(`${API_BASE}api/v3/${tableName}`, data),

  getAll: (isActive) =>
    axios.get(`${API_BASE}api/v3/${tableName}`, {
      params: isActive !== undefined ? { is_active: isActive } : undefined,
    }),

  update: (id, data) => axios.put(`${API_BASE}api/v3/${tableName}/${id}`, data),

  updateStatus: (id, isActive) => axios.patch(`${API_BASE}api/v3/${tableName}/${id}/status`, { is_active: isActive }),

  delete: (id) => axios.delete(`${API_BASE}api/v3/${tableName}/${id}`),
});

export const ConfigTargetGroupsOptAPI = {
  ...createGenericAPI(TableNames.CONFIG_TARGET_GROUPS_OPT),
  // 獲取特定狀態的目標群組
  getActiveGroups: () =>
    axios.get(`${API_BASE}api/v3/${TableNames.CONFIG_TARGET_GROUPS_OPT}`, {
      params: { is_active: true },
    }),
  getInactiveGroups: () =>
    axios.get(`${API_BASE}api/v3/${TableNames.CONFIG_TARGET_GROUPS_OPT}`, {
      params: { is_active: false },
    }),
};

export const ConfigFilterOptAPI = {
  ...createGenericAPI(TableNames.CONFIG_FILTER_OPT),
  // 獲取特定狀態的過濾器
  getActiveFilters: () =>
    axios.get(`${API_BASE}api/v3/${TableNames.CONFIG_FILTER_OPT}`, {
      params: { is_active: true },
    }),
  getInactiveFilters: () =>
    axios.get(`${API_BASE}api/v3/${TableNames.CONFIG_FILTER_OPT}`, {
      params: { is_active: false },
    }),
};

export const ConfigWarningOptAPI = {
  ...createGenericAPI(TableNames.CONFIG_WARNING_OPT),
  // 只取啟用中的警示語範本（給群組下拉用）
  getActiveWarnings: () =>
    axios.get(`${API_BASE}api/v3/${TableNames.CONFIG_WARNING_OPT}`, {
      params: { is_active: true },
    }),
};

export const NotifyGroupAPI = {
  ...createGenericAPI(TableNames.NOTIFY_GROUPS),
  // 獲取特定狀態的過濾器
  getActiveFilters: () =>
    axios.get(`${API_BASE}api/v3/${TableNames.NOTIFY_GROUPS}`, {
      params: { is_active: true },
    }),
  getInactiveFilters: () =>
    axios.get(`${API_BASE}api/v3/${TableNames.NOTIFY_GROUPS}`, {
      params: { is_active: false },
    }),
  updateFilterOpt: (id, opt) => axios.patch(`${API_BASE}api/v3/groups-to-notify/filter-opt/${id}/${opt}`),
  updateTargetGroupOpt: (id, opt) => axios.patch(`${API_BASE}api/v3/groups-to-notify/target-group-opt/${id}/${opt}`),
  // 警示語範本：傳 0 代表「不使用」（後端寫入 NULL）
  updateWarningPhrase: (id, warningPhraseId) =>
    axios.patch(`${API_BASE}api/v3/groups-to-notify/warning-phrase/${id}/${warningPhraseId}`),
};

export const EmailSettingAPI = {
  ...createGenericAPI(TableNames.EMAIL_SETTING),
  // 獲取特定狀態的過濾器
  getActiveFilters: () =>
    axios.get(`${API_BASE}api/v3/${TableNames.EMAIL_SETTING}`, {
      params: { is_active: true },
    }),
  getInactiveFilters: () =>
    axios.get(`${API_BASE}api/v3/${TableNames.EMAIL_SETTING}`, {
      params: { is_active: false },
    }),
};

export const LineConfigAPI = {
  ...createGenericAPI(TableNames.LINE_CONFIG),
  // 獲取特定狀態的過濾器
  getActiveFilters: () =>
    axios.get(`${API_BASE}api/v3/${TableNames.LINE_CONFIG}`, {
      params: { is_active: true },
    }),
  getInactiveFilters: () =>
    axios.get(`${API_BASE}api/v3/${TableNames.LINE_CONFIG}`, {
      params: { is_active: false },
    }),
};

export const TelegramConfigAPI = {
  ...createGenericAPI(TableNames.TELEGRAM_CONFIG),
  // 獲取特定狀態的過濾器
  getActiveFilters: () =>
    axios.get(`${API_BASE}api/v3/${TableNames.TELEGRAM_CONFIG}`, {
      params: { is_active: true },
    }),
  getInactiveFilters: () =>
    axios.get(`${API_BASE}api/v3/${TableNames.TELEGRAM_CONFIG}`, {
      params: { is_active: false },
    }),
};